export default __webpack_public_path__ + "static/media/english-to-finnish-screenshot-05.eef94396.png";